import { render, staticRenderFns } from "./PageAdmin.vue?vue&type=template&id=4cd2fe5e&scoped=true&"
import script from "./PageAdmin.vue?vue&type=script&lang=js&"
export * from "./PageAdmin.vue?vue&type=script&lang=js&"
import style0 from "./PageAdmin.vue?vue&type=style&index=0&id=4cd2fe5e&prod&scoped=true&lang=css&"
import style1 from "./PageAdmin.vue?vue&type=style&index=1&id=4cd2fe5e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd2fe5e",
  null
  
)

export default component.exports